import React, { use, useEffect, useState } from "react";
import { Avatar, Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "antd";
import LoginPageLogo from "../../assets/images/LoginPageLogo.png";
import { Padding } from "@mui/icons-material";
import Styles from "../FeedbackForm/FeedbackForm.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { getProjectByToken } from "../../services/feedbackForm.service";

const QRFormSubmit = () => {
  //   const navigate = useNavigate();
  //   const location = useLocation();
  //   const dataReceived = location.state;

  return (
    <Box>
      {/* Header */}
      <Box className={Styles.Container}>
        <Typography
          style={{
            color: "white",
            fontSize: "24px",
            fontWeight: 700,
            marginLeft: "3%",
          }}
        >
          WSH
        </Typography>
      </Box>

      {/* Content */}
      <Stack className={Styles.Content}>
        <img src={LoginPageLogo} alt="Company Logo" style={{ width: 147 }} />
        <Typography
          style={{
            fontWeight: 600,
            fontSize: "22px",
            marginTop: "20px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          Thank You!
        </Typography>

        <Typography
          style={{
            fontWeight: 400,
            fontSize: "18px",
            alignItems: "center",
            color: "#000000",
            padding: "0px 20px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          {" "}
          Your QR Request has been successfully submitted.
        </Typography>
      </Stack>
    </Box>
  );
};

export default QRFormSubmit;
